import React from 'react';
import { Button, Box } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const BackButton = ({ 
  to = '/admin', 
  label = 'Volver al Panel de Admin',
  sx = {},
  ...props 
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(to);
  };

  return (
    <Box sx={{ mb: 3, ...sx }}>
      <Button
        onClick={handleBack}
        startIcon={<ArrowBackIcon />}
        variant="outlined"
        color="secondary"
        sx={{
          borderColor: 'secondary.light',
          color: 'secondary.main',
          '&:hover': {
            borderColor: 'secondary.main',
            backgroundColor: 'secondary.light',
            color: 'white'
          }
        }}
        {...props}
      >
        {label}
      </Button>
    </Box>
  );
};

export default BackButton; 